import InputGroup from './InputGroup';
import InputGroupAddon from './InputGroupAddon';
import InputGroupButton from './InputGroupButton';

// export types
export type { InputGroupProps } from './InputGroup';
export type { InputGroupAddonProps } from './InputGroupAddon';
export type { InputGroupButtonProps } from './InputGroupButton';

// export components
export { InputGroup, InputGroupAddon, InputGroupButton };
export { InputGroupContext } from './InputGroupContext';
export default InputGroup;
